<template>
  <page-wrapper :title="pageWrapper.title" :has-pad="pageWrapper.hasPad">
    <div class="container">
      <div class="row">
        <div class="col">
          <h1 class="mt-3">รายการ banner</h1>
          <banners-selector
              v-model="pinnedBanners"
              :disabled="disabled"
              class="input"
            ></banners-selector>
        </div>
      </div>
      <div class="row">
        <div class="col text-end padding-adjust">
          <sc-button variant="primary" @click="handleClickSave">บันทึก</sc-button>
        </div>
      </div>
    </div>
  </page-wrapper>
</template>

<script>
import { baanRueJaiClient } from "@/dependencies";
import BannersSelector from "@/lib/components/ArticlesSelector/BannersSelector";
import PageWrapper from "@/lib/components/PageWrapper";
import ScButton from "@/lib/components/ScButton";
import { transformBannerResponseToBannerListItem } from "../transform";

export default {
  components: {
    PageWrapper,
    ScButton,
    'banners-selector': BannersSelector
  },
  data() {
    const pageWrapper = {
      title: "Pinned แบนเนอร์",
      hasPad: false
    };
    const pinnedBanners = [];
    const disabled = false;
    return {
      pageWrapper,
      pinnedBanners,
      disabled
    }
  },
  created() {
    this.setup();
  },
  methods: {
    async setup() {
      const pinnedResponse = await baanRueJaiClient.admin.articles.getPin('PINNED_ARTICLE_BANNER');
      const pinnedBanners = pinnedResponse.data.result.map((item) => item.article_id);
      this.pinnedBanners = pinnedResponse.data.result.map((item) =>
        transformBannerResponseToBannerListItem(item, pinnedBanners)
      );
    },
    async handleClickSave() {
      try {
        const requestPinnedBanners = this.pinnedBanners.map(
          pinnedBanner => pinnedBanner.id
        );
        const params = {
          article_ids: requestPinnedBanners
        };
        await baanRueJaiClient.admin.articles.putPin(
          "PINNED_ARTICLE_BANNER",
          params
        );

        this.$message.success("บันทึกสำเร็จ");
      } catch (error) {
        this.$message.error("ไม่สามารถบันทึก ได้ กรุณาลองใหม่อีกครั้ง");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.padding-adjust {
  padding: 20px;
}
</style>
